import axios from "axios";
import ConnUrls from '../ConnectURL'



const getSpecialPageByName = async (pageName) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "specialP/" + pageName);
    return (dFromF.data);
}
const getStaticPageByName = async (pageName) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "specialP/Statics/" + pageName);
    return (dFromF.data);
}


export default {
    getSpecialPageByName,
    getStaticPageByName
};